<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Candidatos" variant="title-only"></app-page-header>

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="id">#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-stroked-button color="basic" routerLink="/usuario-candidato/{{ row.id }}/email">
            Alterar e-mail
          </button>
          &nbsp;
          <button mat-stroked-button color="basic" routerLink="/usuario-candidato/{{ row.id }}/senha">
            Alterar senha
          </button>
          <!-- &nbsp;
          <button mat-stroked-button color="basic" routerLink="/usuario-candidato/{{ row.id }}/vincular-emails">
            Vincular Contas
          </button> -->
        </td>
        &nbsp;
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>
</div>
